import axios from "axios"
import { apiUrl } from "../enumerations/constants"

export const createRequest = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/request`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const updateRequest = async (token, payload) => {
  const { data: response } = await axios.put(`${apiUrl}/request`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const deleteRequest = async (token, id) => {
  const { data: response } = await axios.delete(`${apiUrl}/request/${id}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const getRequests = async (token, query) => {
  const { data: response } = await axios.get(`${apiUrl}/requests?${query}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const getRequest = async (token, id) => {
  const { data: response } = await axios.get(`${apiUrl}/request?id=${id}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const completeRequests = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/requests/complete`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const completeRequest = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/request/complete`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}